<template>
  <div class="step">
    <div class="text-center">
      <div align-h="center">
        <div>
          <h2>OK, where should we start?</h2>
          <p>Choose the area you feel the most confident about, and we can go from there.</p>
          <div class="step__options">
            <div class="step__option">
              <div class="styled-radio">
                <icon-school />
                <input id="path-select-school" type="radio" v-model="user.path" value="school"> <label for="path-select-school">I’ve got some schools in mind.</label>
              </div>
            </div>
            <div class="step__option">
              <div class="styled-radio">
                <icon-book />
                <input id="path-select-major" type="radio" v-model="user.path" value="major"> <label for="path-select-major">I’m considering a major.</label>
              </div>
            </div>
            <div class="step__option">
              <div class="styled-radio">
                <icon-briefcase />
                <input id="path-select-career" type="radio" v-model="user.path" value="career"> <label for="path-select-career">I’ve started thinking about my career.</label>
              </div>
            </div>
            <div class="step__option">
              <div class="styled-radio">
                <icon-undecided />
                <input id="path-select-unknown" type="radio" v-model="user.path" value="unknown"> <label for="path-select-unknown">I’m not sure where to start.</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-left no-gutters" align-h="center">
        <disclaimer />
      </div>
    </div>
  </div>
</template>

<script>
import IconSchool from '../animatedicons/IconSchool.vue'
import IconBook from '../animatedicons/IconBook.vue'
import IconBriefcase from '../animatedicons/IconBriefcase.vue'
import IconUndecided from '../animatedicons/IconUndecided.vue'
import Disclaimer from '../Disclaimer.vue'

export default {
  name: 'PathSelectStep',
  props: {
    user: Object
  },
  components: {
    IconSchool,
    IconBook,
    IconBriefcase,
    Disclaimer,
    IconUndecided
  },
  mounted: function () {
    if (this.user.path) {
      this.user.path = null;
    }
  },
  watch: {
    'user.path': function () {
      // depending on path, make assumptions about `CareerKnownStep`
      if (this.user.path === 'school') {
        this.user.schoolKnown = 'yes';
      }
      else if (this.user.path === 'career') {
        this.user.careerKnown = 'yes';
      }
      else if (this.user.path === 'major') {
        this.user.careerKnown = 'no';
      }

      if (this.user.path) {
        this.$emit('completed');
      }
    },
  }
}
</script>

<style scoped>
</style>
